
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import UIMoneyFormat from "@/components/UI/Money/UIMoneyFormat.vue";
import { isColorDark } from '@/utilities/colorUtils';

export default Vue.extend({
    props: ["drawer"],

    components: {
        "money-formatter": UIMoneyFormat,
    },

    computed: {
        ...mapState("ui", ["isMobileViewDisplayed"]),
        ...mapState("auth", ["preferredOrderType"]),
        ...mapState("store", ["selectedStoreDetails"]),
        ...mapState("partner", ["partnerSettings"]),

        ...mapGetters("cart", ["currentSelectedCartTotalAmount", "currentSelectedCartTotalQuantity"]),

        cartDrawer: {
            get(): boolean {
                return (this as any).drawer;
            },
            set(value: boolean) {
                this.$emit("changed", value);
            }
        },

        
        cartBtnBackgroundColor(): string {
            return this.partnerSettings.cartBtnBackgroundColor == null || this.partnerSettings.cartBtnBackgroundColor == "" 
                ? this.partnerSettings.actionButtonColor 
                :  this.partnerSettings.cartBtnBackgroundColor;
        },

        iscartBtnBackgroundColorDark(): boolean {
            return isColorDark(this.cartBtnBackgroundColor);
        },


    },

    model: {
        prop: "drawer",
        event: "changed"
    }
})
